<template>
  <div>
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="card card-wizard" id="wizardCard">
          <form-wizard ref="wizard"
                       @on-complete="wizardComplete"
                       @on-change="scrollToTop"
                       error-color="#31bebf"
                       title="HEALTHTRACK RX"
                       subtitle=""
                       color='#31bebf'>
  
            <tab-content :title="translatedFields['site']"
                         :before-change="validateFirstStep"
                         icon="ti-user">
              <first-step ref="firstStep"
                          v-on:jumpToTheNextPage="jumpToTheNextPage">
              </first-step>
            </tab-content>

            <tab-content :title="translatedFields['requisition']"
                         :before-change="validateSecondStep"
                         icon="ti-settings">
              <second-step ref="secondStep"
                           v-on:jumpToTheFourthPage="jumpToTheFourthPage"
                           v-on:nextTab="nextTab">
              </second-step>
            </tab-content>

            <tab-content :title="translatedFields['medical_data']"
                         :before-change="validateThirdStep"
                         icon="ti-settings">
              <third-step ref="thirdStep"
                           v-on:nextTab="nextTab">
              </third-step>
            </tab-content>

            <tab-content :title="translatedFields['results']"
                         icon="ti-check">
              <fourth-step ref="fourthStep"
                          v-on:nextTab="nextTab"
              ></fourth-step>
            </tab-content>

            <button slot="prev" class="btn btn-default btn-fill btn-wd btn-back"><span>{{ translatedFields['back'] }} </span></button>
            <button slot="next" class="btn btn-fill btn-wd btn-next"><span> {{ translatedFields['next'] }}</span></button>
            <a slot="finish" class="display-none"></a>
            </form-wizard>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {mapFields} from 'vee-validate'
  import FirstStep from './Wizard/SiteSelectionStep.vue'
  import SecondStep from './Wizard/PatientMatchRegistration.vue'
  import ThirdStep from './Wizard/MedicationDataStep.vue'
  import FourthStep from './Wizard/Result.vue'

  export default {
    data () {
      return {
        confirmationNumber: '',
        translatedFields: '',
        fields_en: {
          next: 'Next',
          back: 'Back',
          update: 'Update',
          results: 'Results',
          patient_registration_form: 'Patient Registration Form',
          site: 'Site',
          medical_data: 'Medical Data',
          requisition: 'Requisition',
          insurance_information: 'Insurance Information',
          submission: 'Submission',
          check_your_results: 'Check your results',
          here: 'here'
        },
        secondStep: '',
        allow_results: String(process.env.ALLOW_RESULTS) === 'true',
        allow_telehealth: String(process.env.ALLOW_TELEHEALTH) === 'true',
        allow_insurance: String(process.env.ALLOW_INSURANCE) === 'true',
        disabled: false,
        wizardModel: {}
      }
    },
    components: {
      FirstStep,
      SecondStep,
      ThirdStep,
      FourthStep
    },
    mounted: function () {
      this.$sidebar.isMinimized = true
    },
    methods: {
      nextTab () {
        this.$refs.wizard.nextTab()
      },
      jumpToTheNextPage () {
        // this method will jump to the next page without any validation
        // do not use it
        this.$refs.wizard.changeTab(0, 1)
      },
      jumpToTheFourthPage () {
        // this method will jump to the next page without any validation
        // do not use it
        this.$refs.wizard.changeTab(2, 3)
      },
      checkLanguage () {
        if (this.$store.state.lang.value === 'ES') {
          this.translatedFields = this.$store.state.translation_es
        } else {
          if (this.$store.state.lang.value === 'ZH') {
            this.translatedFields = this.$store.state.translation_zh
          } else {
            this.translatedFields = this.fields_en
          }
        }
      },
      validateFirstStep () {
        return this.$refs.firstStep.validate()
      },
      validateSecondStep () {
        this.secondStep = true
        return this.$refs.secondStep.validate()
      },
      validateThirdStep () {
        return this.$refs.thirdStep.validate()
      },
      validateFourthStep () {
        return this.$refs.fourthStep.validate()
      },
      wizardComplete: function () {
        this.disabled = true
        this.wizardModel = {
          ...this.$refs.firstStep.model,
          ...this.$refs.secondStep.model,
          ...this.$refs.thirdStep.model,
          ...this.$refs.fourthStep.model
        }
      },
      scrollToTop () {
        let elmnt = document.getElementsByClassName('main-panel')[0]
        elmnt.scrollTo(0, 0)
      }
    },
    computed: {
      ...mapFields(['callingSchedule']),
      language () {
        this.checkLanguage()
        return this.$store.state.lang.value
      },
      spanishFields () {
        return this.$store.state.translation_es
      },
      chineseFields () {
        return this.$store.state.translation_zh
      }
    },
    watch: {
      language () {
        this.checkLanguage()
      }
    }
  }
</script>
<style scoped>
  >>> .vue-form-wizard .wizard-icon-circle {
    background-color: white;
    color: #000000;
    border: 3px solid #323737;
  }

  >>> .vue-form-wizard .wizard-nav-pills>li>a {
    color: #323737;
  }

  >>> div[aria-selected="true"]{
    background-color: #31bebf !important;
  }

  span button {
    transition: 0.5s;
  }

  .btn-next {
    background-color: white !important;
    color: #323737 !important;
    min-height: 40px;
    border: 2px solid #31bebf !important;
    border-radius: 20px;
  }

  .btn-next:hover{
    border: none;
    background-color: #31bebf !important;
    color: white !important;
    padding-right: 25px;
  }

  .btn-next:focus{
    border: none !important;
    background-color: #31bebf !important;
    color: white !important;
    padding-right: 25px;
  }

  .btn-next span:after {
    content: '\00bb';
    opacity: 1;
    font-size: 17px;
    margin-left: 5px;
  }

  .btn-back{
    background-color: transparent !important;
    color: #f4c617 !important;
    min-height: 40px;
    border: none;
    border-radius: 20px;
  }

  .btn-back span:before {
    content: '\00AB';
    opacity: 1;
    font-size: 17px;
    margin-right: 5px;
  }

  .btn-back:hover{
    border: none !important;
    background-color: #f4c617 !important;
    color: white !important;
    padding-right: 25px;
  }

  .btn-back:focus{
    border: none !important;
    background-color: #f4c617 !important;
    color: white !important;
    padding-right: 25px;
  }

  .btn-submit{
    background-color: white !important;
    color:  #323737 !important;
    min-height: 40px;
    border: 2px solid #31bebf !important;
    border-radius: 20px;
  }

  .btn-submit:hover{
    border: none;
    background-color: #31bebf !important;
    color: white !important;
    padding-right: 25px;
  }

  .btn-submit:focus{
    border: none;
    background-color: #31bebf !important;
    color: white !important;
    padding-right: 25px;
  }

  .btn-submit span:after {
    content: '\2713';
    opacity: 1;
    font-size: 17px;
    margin-left: 5px;
  }

  .m-50{
    margin-top: 20px;
    padding-bottom: 20px;
    margin-left: 20px;
  }

  .htrx-primary{
    color: #31bebf;
  }

  @media (max-width: 400px) {
    >>> .vue-form-wizard .wizard-card-footer {
      display: -webkit-box;
      display: -moz-box;
      display: box;

      -webkit-box-orient: vertical;
      -moz-box-orient: vertical;
      box-orient: vertical;
    }

    >>> .vue-form-wizard .wizard-card-footer .wizard-footer-right {
      position: relative;
      min-height: 1px;
      width: 100%;
      margin-top: 10px;

      -webkit-box-ordinal-group: 1;
      -moz-box-ordinal-group: 1;
      box-ordinal-group: 1;
    }

    >>> .vue-form-wizard .wizard-card-footer .wizard-footer-left {
      position: relative;
      min-height: 1px;
      width: 100%;

      -webkit-box-ordinal-group: 2;
      -moz-box-ordinal-group: 2;
      box-ordinal-group: 2;
    }

    .btn-back{
      width: 100%;
    }

    .btn-next{
      width: 100%;
    }

    .btn-submit{
      width: 100%;
    }

    >>> span[role=button] {
      width: 100% !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/PatientMatch/PatientMatchWizard.vue